module.exports = __webpack_public_path__ + "images/person-sitting.svg";